export default {
    common: {
        title: 'Editar Imagem',
        cancel: 'Cancelar',
        save: 'Guardar',
        crop: 'Agricultura',
        adjustments: 'Ajustamentos',
        filters: 'Filtros',
        frames: 'Quadros',
        overlays: 'Camadas sobrepostas',
        text: 'Texto',
        stickers: 'Autocolantes',
        brush: 'Escova',
        ai: 'Criar imagem utilizando IA',
        reset: 'Reiniciar',
        comingSoon: 'Brevemente...',
        apply: 'Aplicar',
        undo: 'Desfazer',
        redo: 'Refazer',
        flipHorizontal: 'Inverter Horizontalmente',
        flipVertical: 'Inverter verticalmente',
        rotateClockwise: 'Rodar no sentido dos ponteiros do relógio',
        rotateAntiClockwise: 'Rodar para a esquerda',
        warning: 'Aviso',
        discard: 'Descartar',
        continue: 'Continua a editar',
        discardHeading: 'Descartar as suas alterações?',
        discardSubHeading: 'Se fechares o editor de imagens, as tuas alterações não serão guardadas',
        subtitle: 'Os formatos de imagem suportados são PNG e JPEG',
        clone: 'Clonar',
        delete: 'Apagar',
    },
};
